import extendNode from '../extendNode.mjs'
import Color from '../Color.mjs'
import useComponentNode from '../_COMPONENT/useComponentNode.jsx'
import usePropertiesModal from '../hooks/usePropertiesModal.jsx'
import IconFile from '../icons/IconFile.jsx'
import IconLetters from '../icons/IconLetters.jsx'
import IconStar from '../icons/IconStar.jsx'
import meta from './metaFj.mjs'
import Model from './ModelFj.mjs'
import ModalProperties from './ModalPropertiesFj.jsx'
import PropertiesPane from './PropertiesPaneFj.jsx'

export default () => {
    const ComponentNode = useComponentNode()
    const openPropertiesModal = usePropertiesModal(ModalProperties)

    return extendNode(ComponentNode, {
        ...meta,
        Model,
        PropertiesPane,

        canLinkType(map, node, type) {
            return /^(DT|FC|LSI)$/.test(type)
        },

        canMountType(map, node, type) {
            return /^(DOC)$/.test(type)
        },

        getIcons(map, node) {
            const icons = []

            const {
                dtOprCode,
                fjFcCode,
                fjLsiCode,
                fjTypeCode,
                fmFjDtList = [],
            } = node.data

            if ('DT' === fjTypeCode) {
                if ('C' === dtOprCode) {
                    icons.push(
                        <IconLetters
                            fill={Color.GREEN_YELLOW}
                            letters="C"
                            textColor="#666"
                        />
                    )
                }
                else if ('D' === dtOprCode) {
                    icons.push(
                        <IconLetters
                            fill={Color.GREEN_YELLOW}
                            letters="D"
                            textColor="#666"
                        />
                    )
                }
                else if ('R' === dtOprCode) {
                    icons.push(
                        <IconLetters
                            fill={Color.GREEN_YELLOW}
                            letters="R"
                            textColor="#666"
                        />
                    )
                }
                else if ('U' === dtOprCode) {
                    icons.push(
                        <IconLetters
                            fill={Color.GREEN_YELLOW}
                            letters="U"
                            textColor="#666"
                        />
                    )
                }

                if (0 < fmFjDtList.length) {
                    icons.push(<IconStar fill={Color.RED} />)
                }
                else {
                    icons.push(<IconStar fill={Color.GREY} />)
                }
            }
            else if ('FC' === fjTypeCode) {
                icons.push(
                    <IconLetters
                        fill={Color.GREEN_YELLOW}
                        letters="A"
                        textColor="#666"
                    />
                )

                if (fjFcCode) {
                    icons.push(<IconStar fill={Color.RED} />)
                }
                else {
                    icons.push(<IconStar fill={Color.GREY} />)
                }
            }
            else if ('FILE' === fjTypeCode) {
                icons.push(
                    <IconFile
                        fill={Color.GREEN_YELLOW}
                        theme="dark"
                    />
                )
            }
            else if ('LSI' === fjTypeCode) {
                icons.push(
                    <IconLetters
                        fill={Color.GREEN_YELLOW}
                        letters="LI"
                        textColor="#666"
                    />
                )

                if (fjLsiCode) {
                    icons.push(<IconStar fill={Color.RED} />)
                }
                else {
                    icons.push(<IconStar fill={Color.GREY} />)
                }
            }
            else if ('NEW' === fjTypeCode) {
                icons.push(
                    <IconLetters
                        letters="N"
                        textColor={Color.GREEN}
                    />
                )
            }
            else if ('VERIFY' === fjTypeCode) {
                icons.push(
                    <IconLetters
                        fill="#f88634"
                        letters="!"
                        textColor="#fff"
                    />
                )
            }

            return icons
        },

        getRev(map, node) {
            return null
        },

        getStyle(map, node) {
            return {
                ...this._getStyle(map, node, {
                    borderColor: Color.GREEN_YELLOW,
                }),

                shape: 'Parallelogram',
            }
        },

        menuItemsInsertCommon(map, node) {
            return [
                {type: 'DOC'},
            ]
        },

        menuItemsInsertProduct(map, node) {
            return [
                {type: 'DT'},
                {type: 'LSI'},
                {type: 'FC'},
            ]
        },

        async onDoubleClick(map, node, event) {
            if (this.isMounted(map, node)) {
                event.preventDefault()
                openPropertiesModal(map, node, Model)
            }
            else {
                await ComponentNode.onDoubleClick.call(this, map, node, event)
            }
        },

        async _atPull(map, node) {
            await ComponentNode._atPull.call(this, map, node)
            node.isFolded = false
        },

        async _atOwnerPush(map, node, event) {
            const {dtOprCode, fjTypeCode} = node.data

            const d = {
                fjFcCode: '',
                fjLsiCode: '',
                fjLsSysId: '',
                fjSsCode: '',
                fmFjDtList: [],
            }

            ;({
                DT: () => {
                    for (const n of map.children(node)) {
                        const {bizNodeType} = n.data

                        if ('DT' === bizNodeType) {
                            const {
                                pkid: dtId,
                                [map.BizNode.DT.textProp]: dtName
                            } = n.data

                            d.fmFjDtList.push({dtId, dtName})

                            if (/^[CDU]$/.test(dtOprCode)) {
                                break
                            }
                        }
                    }
                },

                FC: () => {
                    for (const n of map.children(node)) {
                        const {bizNodeType} = n.data

                        if ('FC' === bizNodeType) {
                            const {
                                fcCode: fjFcCode,
                                ssCode: fjSsCode,
                            } = n.data

                            Object.assign(d, {fjFcCode, fjSsCode})
                            break
                        }
                    }
                },

                LSI: () => {
                    for (const n of map.children(node)) {
                        const {bizNodeType} = n.data

                        if ('LSI' === bizNodeType) {
                            const {
                                lsiCode: fjLsiCode,
                                lsId: fjLsSysId,
                            } = n.data

                            Object.assign(d, {fjLsiCode, fjLsSysId})
                        }
                    }
                },
            }[fjTypeCode])?.()

            const pushData = await this._getPushData(map, node)
            event.detail.fmFjList.push({...pushData, ...d})
        },

        _getDefaultDataFields(map, node) {
            return {
                ...ComponentNode._getDefaultDataFields.call(this, map, node),
                fjTypeCode: 'KEY',
                txNo: '1',
            }
        },
    })
}
